"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZAwardFreeEntriesRequest = exports.ZTicketDetails = exports.ZTicketEntrySelect = exports.ZTicketSelect = exports.ZDrawOrderSelect = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../../generated/zodSchemas.generated");
const models_1 = require("../../order/models");
const models_2 = require("../../subscription/models");
const utils_1 = require("../../utils");
const draw_1 = require("../draw");
exports.ZDrawOrderSelect = zodSchemas_generated_1.zodSelectDrawOrder
    .pick({
    id: true,
    status: true,
    orderId: true,
    playerId: true,
    firstDrawId: true,
    drawTypeCode: true,
    entries: true,
    price: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
    entries: zod_1.z.array(dbJsonModels_1.ZEntryLine),
});
exports.ZTicketSelect = zodSchemas_generated_1.zodSelectTicket
    .pick({
    id: true,
    status: true,
    playerId: true,
    drawOrderId: true,
    drawId: true,
    drawTypePlanId: true,
    cost: true,
    paid: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
});
exports.ZTicketEntrySelect = zodSchemas_generated_1.zodSelectTicketEntry
    .pick({
    id: true,
    ticketId: true,
    entry: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
});
exports.ZTicketDetails = zod_1.z.object({
    ticket: exports.ZTicketSelect,
    entries: zod_1.z.array(dbJsonModels_1.ZEntryLine),
    draw: draw_1.ZDrawSelect,
    drawSchedule: draw_1.ZDrawScheduleSelect,
    drawType: draw_1.ZDrawTypeSelect,
    drawTypePlan: draw_1.ZDrawTypePlanSelect,
    paymentRequest: models_1.ZPaymentRequestSelect,
    subscription: models_2.ZSubscriptionSelect.optional().nullable(),
});
exports.ZAwardFreeEntriesRequest = zod_1.z.object({
    firstName: zod_1.z.string().min(1).max(100).optional(),
    lastName: zod_1.z.string().min(1).max(100).optional(),
    playerEmail: zod_1.z.string().email(),
    type: models_1.ZPurchasingAction,
    drawTypeCode: zod_1.z.string(),
    drawScheduleId: zod_1.z.coerce.number(),
    drawScheduleCode: zod_1.z.string(),
    drawTypePlanCode: zod_1.z.string(),
    drawTypePlanSubcode: zod_1.z.string(),
    numOfEntries: zod_1.z.coerce.number(),
    sendEmail: utils_1.booleanParamSchema,
});
//# sourceMappingURL=models.js.map